@if (sessionRefreshRequired()) {
  <ac-card>
    <ac-card-content>
      <div class="kyc-dialog ac-flex ac-flex-ctr ac-flex-col ac-gap-lg">
        <div class="ac-flex ac-ctr">
          <ac-icon iconKey="hr:security_shield" [size]="60"></ac-icon>
        </div>
        <div class="ac-flex ac-flex-col ac-ctr ac-gap-sm" [style.text-align]="'center'">
          <div class="ac-headline-sm">Security Check Required</div>
          <div class="ac-body-md ac-label">
            To help protect your account and complete this verification, we need to refresh your secure session. Please log out and log back in to continue.
          </div>
        </div>
        <button mat-flat-button class="ac-btn-lg" (click)="logout()">Log Out</button>
      </div>
    </ac-card-content>
  </ac-card>
} @else {
  <ac-card>
    @if (kycStatus() === 'none') {
      <ac-card-content>
        <div class="kyc-dialog ac-flex ac-flex-ctr ac-flex-col ac-gap-lg">
          <div class="ac-flex ac-sp-btw">
            <div [style.width.px]="46"></div>
            <img
              class="kyc-image"
              [width]="100"
              [height]="100"
              [src]="('cdnUrl' | env) + '/images/kyc.webp'"
              alt="kyc-image"
            />
            <button
              (click)="close()"
              mat-icon-button
              class="close-button ac-icon-btn-sm"
            >
              <ac-icon iconKey="hr:xmark" [size]="20"></ac-icon>
            </button>
          </div>
          <div>
            <div class="ac-headline-sm">Verification Required</div>
            <div class="ac-body-md ac-label">
              To comply with regulations, we need to securely verify your identity.
              Once we are able to verify your identity, you will have full access to
              the platform.
            </div>
          </div>
        </div>
      </ac-card-content>
    }
    @if (kycStatus() === 'approved') {
      <ac-card-header (close)="close()">
        <div>
          <span class="ac-headline-sm" [style.line-height.px]="32">Verification complete</span>
          <div class="ac-body-md ac-label">
            Your account has successfully been verified.
          </div>
        </div>
      </ac-card-header>
    }
    @if (kycStatus() === 'rejected') {
      <ac-card-header (close)="close()">
        <div>
          <span class="ac-headline-sm" [style.line-height.px]="32">Verification failed</span>
          <div class="ac-body-md ac-label">
            Your account verification has failed.
          </div>
        </div>
      </ac-card-header>
    }
    @if (kycStatus() === 'pending') {
      <ac-card-header (close)="close()">
        <div>
          <span class="ac-headline-sm" [style.line-height.px]="32">Verification in progress</span>
          <div class="ac-body-md ac-label">
            Your verification attempt is currently processing. You will receive a
            notification when your verification is complete.
          </div>
        </div>
      </ac-card-header>
    }

    <ac-card-content>
      <div class="kyc-dialog ac-flex ac-flex-col ac-gap-lg ac-ctr">
        <app-kyc-wizard
          [autoContinueOnApproved]="false"
          [fullWidthButtons]="true"
          [largeButtons]="true"
          (statusChange)="onKycStatusChange($event)"
          (verifyLater)="onVerifyLater()"
          (continue)="onKycContinue()"
        >
        </app-kyc-wizard>
      </div>
    </ac-card-content>
  </ac-card>
}
